import { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { Footer, Header } from "../lib/shared"
import { revalidateContent, useSettings } from "../lib/content"
import Maintenance from "../pages/Maintenance"

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    // Let in-page hash links resolve to their target; otherwise reset to top.
    if (hash) {
      // Wait a frame so the target section is mounted before scrolling.
      const id = window.setTimeout(() => {
        const el = document.querySelector(hash)
        if (el) el.scrollIntoView({ behavior: "smooth" })
        else window.scrollTo(0, 0)
      }, 60)
      return () => window.clearTimeout(id)
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])
  return null
}

export default function Root() {
  const { settings } = useSettings()

  /*
    The page was built from a snapshot of content taken at build time. Refresh
    it once after hydration so a published post, or a maintenance-mode toggle,
    reaches visitors in seconds rather than waiting on the next deploy. Runs
    after hydration, never during it, so the markup React adopted still matches
    what the server sent.
  */
  useEffect(() => {
    void revalidateContent()
  }, [])

  // When maintenance mode is on, the public site is replaced by the
  // maintenance page. The /admin routes live in a separate route tree,
  // so the dashboard stays reachable to toggle it back off.
  if (settings.maintenance) {
    return <Maintenance />
  }

  return (
    <div className="min-h-screen bg-white text-ink antialiased">
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
